<template>
  <div class="hand-up-msg-comp">
    <img
      class="hand-icon"
      src="../../../assets/images/live/hand-color.png"
      alt=""
    />
    <span class="nick-name">{{ msgItem.nickname }}</span>

    <loading-button
      :is-active="isUserSteppedUp"
      @click-async="handlePermissionToggleClick('downstage')"
      ref="downstageBtnRef"
    >
      <template v-slot:active-icon>
        <img src="../../../assets/images/live/step-down-open.png" alt="下台" />
      </template>
      <template v-slot:inactive-icon>
        <img src="../../../assets/images/live/step-down-close.png" alt="上台" />
      </template>
    </loading-button>

    <!-- 已上台 -->
    <template v-if="isUserSteppedUp">
      <loading-button
        v-if="roomInfo.mode != 1"
        :is-active="isVideoOpen"
        @click-async="handlePermissionToggleClick('videoMute')"
        ref="videoMuteBtnRef"
      >
        <template v-slot:active-icon>
          <img src="../../../assets/images/live/video-open.png" />
        </template>
        <template v-slot:inactive-icon>
          <img src="../../../assets/images/live/video-close.png" />
        </template>
      </loading-button>
      <loading-button
        :is-active="isAudioOpen"
        @click-async="handlePermissionToggleClick('audioMute')"
        ref="audioMuteBtnRef"
      >
        <template v-slot:active-icon>
          <img src="../../../assets/images/live/mic-open.png" />
        </template>
        <template v-slot:inactive-icon>
          <img src="../../../assets/images/live/mic-close.png" />
        </template>
      </loading-button>
    </template>

    <loading-button
      :is-active="isWhiteboardOpen"
      @click-async="handlePermissionToggleClick('whiteboard')"
      ref="whiteboardBtnRef"
    >
      <template v-slot:active-icon>
        <img
          src="../../../assets/images/live/whiteboard-open.png"
          alt="打开白板"
        />
      </template>
      <template v-slot:inactive-icon>
        <img
          src="../../../assets/images/live/whiteboard-close.png"
          alt="关闭白板"
        />
      </template>
    </loading-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { setUserRole } from "@saas/service-api/src/live-sdk";
import LoadingButton from "./LoadingButton.vue";
import { EventBus } from "@saas/components/src/utils/event-bus";

export default {
  props: {
    msgItem: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    LoadingButton,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("live", ["imService", "roomInfo", "liveService"]),
    isUserSteppedUp() {
      return this.msgItem.is_up_stage === 1;
    },
    isWhiteboardOpen() {
      return this.msgItem.is_whiteboard === 1;
    },
    isVideoOpen() {
      return this.msgItem.video_state === 1;
    },
    isAudioOpen() {
      return this.msgItem.audio_state === 1;
    },
  },
  mounted() {
    this.initEventBus();
    this.initImEvent();
  },
  methods: {
    initImEvent() {
      this.imService.on("recvMGLiveRoomCustomMsg", (res) => {
        const { data } = res;
        if (data.type === "videoMute") {
          if (this.msgItem.user_id === data.data.userId) {
            this.msgItem.video_state = data.data.isMute ? 2 : 1;
          }
        } else if (data.type === "audioMute") {
          if (this.msgItem.user_id === data.data.userId) {
            this.msgItem.audio_state = data.data.isMute ? 2 : 1;
          }
        } else if (data.type === "whiteboard") {
          if (this.msgItem.user_id === data.data.userId) {
            this.msgItem.is_whiteboard = data.data.isWhiteboard ? 1 : 2;
          }
        } else if (data.type === "downstage") {
          if (this.msgItem.user_id === data.data.userId) {
            this.msgItem.is_up_stage = data.data.isDown ? 2 : 1;
          }
        } else if (data.type === "userStatus") {
          if (this.msgItem.user_id === data.data.user_id) {
            this.msgItem.video_state = data.data.video_state;
            this.msgItem.audio_state = data.data.audio_state;
          }
        }
      });
    },
    initEventBus() {
      EventBus.$on("downstage", (res) => {
        if (this.msgItem.user_id === res.userId) {
          this.msgItem.is_up_stage = res.isDown ? 2 : 1;
        }
      });
      EventBus.$on("videoMute", (res) => {
        if (this.msgItem.user_id === res.userId) {
          this.msgItem.video_state = res.isMute ? 2 : 1;
        }
      });
      EventBus.$on("audioMute", (res) => {
        if (this.msgItem.user_id === res.userId) {
          this.msgItem.audio_state = res.isMute ? 2 : 1;
        }
      });
      EventBus.$on("whiteboard", (res) => {
        if (this.msgItem.user_id === res.userId) {
          this.msgItem.is_whiteboard = res.isWhiteboard ? 1 : 2;
        }
      });
    },
    async handlePermissionToggleClick(type) {
      const button = this.$refs[`${type}BtnRef`];
      try {
        let customMsg = {};
        let setUserRoleData = {};
        switch (type) {
          case "downstage":
            customMsg = {
              isDown: this.isUserSteppedUp,
              isWhiteboard: this.roomInfo.up_stage_whiteboard, // 1  可操作
              isSendAudio: this.roomInfo.up_stage_audio, // 1 可操作
              isSendVideo: this.roomInfo.up_stage_video, // 1 可操作
            };
            setUserRoleData = {
              is_up_stage: this.isUserSteppedUp ? 2 : 1,
            };
            break;
          case "whiteboard":
            customMsg = {
              isWhiteboard: !this.isWhiteboardOpen,
            };
            setUserRoleData = {
              is_whiteboard: this.isWhiteboardOpen ? 2 : 1,
            };
            break;
          case "videoMute":
            customMsg = {
              isMute: this.isVideoOpen,
            };
            setUserRoleData = {
              is_send_video: this.isVideoOpen ? 2 : 1,
            };
            break;
          case "audioMute":
            customMsg = {
              isMute: this.isAudioOpen,
            };
            setUserRoleData = {
              is_send_audio: this.isVideoOpen ? 2 : 1,
            };
        }
        this.setUserRole({
          ...setUserRoleData,
        })
          .then((res) => {
            if (res.code === 1) {
              const data = {
                cmdId: 2,
                data: {
                  type,
                  data: {
                    userId: this.msgItem.user_id,
                    ...customMsg,
                  },
                },
              };
              // 发送im 自定义消息
              this.imService.sendMGLiveRoomCustomMsg(data);
              // 修改
              this.$emit("updateMsgItem", type);
              if (type === "downstage") {
                EventBus.$emit("downstage", {
                  userId: this.msgItem.user_id,
                  isDown: customMsg.isDown,
                });
              } else if (type === "videoMute" && this.isVideoOpen) {
                EventBus.$emit("videoMute", {
                  userId: this.msgItem.user_id,
                  isMute: customMsg.isMute,
                });
              } else if (type === "audioMute" && this.isAudioOpen) {
                EventBus.$emit("audioMute", {
                  userId: this.msgItem.user_id,
                  isMute: customMsg.isMute,
                });
              } else if (type === "whiteboard") {
                console.log("whiteboard________", this.isWhiteboardOpen);
                EventBus.$emit("whiteboard", {
                  userId: this.msgItem.user_id,
                  isWhiteboard: customMsg.isWhiteboard,
                });
              }
            } else {
              this.$darkMessage.error(res.message);
            }
            button.setLoading(false);
          })
          .catch((err) => {
            this.$darkMessage.error("操作失败");
            button.setLoading(false);
          });
      } catch (error) {
        console.error("Step Up/Down toggle failed:", error);
      } finally {
        button.setLoading(false);
      }
    },

    setUserRole(data) {
      return setUserRole({
        ...data,
        user_id: this.msgItem.user_id,
        room_id: this.roomInfo.id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hand-up-msg-comp {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  color: #ffffff;
  line-height: 1;
  .hand-icon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
  .nick-name {
    margin-right: 2px;
  }
  .operate-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 2px;

    img {
      width: 22px;
      height: 22px;
    }

    // Styles for disabled and loading-icon are now defined in LoadingButton.vue
    // but ensuring operate-btn provides the base for layout and margin
  }
}
// Removed old loading-specific CSS from here as it's in LoadingButton.vue
</style>
